"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavHomeButtons = void 0;
var inversify_react_1 = require("inversify-react");
var react_1 = __importStar(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Navigation_1 = require("./Navigation");
var Telemetry_1 = require("@CommonFrontend/Telemetry");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var NewFeatureIndicator_1 = require("./NewFeatureIndicator");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var NavHomeButtons_css_1 = require("./NavHomeButtons.css");
var BetaTag_1 = require("Common/BetaTag/BetaTag");
var styles = __importStar(require("./Navigation.css"));
var LibraryDashboardType;
(function (LibraryDashboardType) {
    LibraryDashboardType["EngagementLibrary"] = "engagement-library";
    LibraryDashboardType["Templates"] = "templates";
    LibraryDashboardType["Automations"] = "automations";
})(LibraryDashboardType || (LibraryDashboardType = {}));
var c = (0, BemBuilder_1.default)(Navigation_1.BASE_CLASS_NAME);
var NavHomeButtons = function (_a) {
    var $state = _a.$state, hideBlocksButton = _a.hideBlocksButton, onPagesClick = _a.onPagesClick, activeNav = _a.activeNav, user = _a.user, rolesService = _a.rolesService;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    var isAdmin = rolesService.isAdmin(user);
    function goToAnalytics() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Analytics);
        $state.go("analytics");
    }
    function goToBlocks() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Blocks);
        $state.go("dashboard", { nav: "blocks" });
    }
    function goToLibraryDashboard(type) {
        $state.go("dashboard", { nav: type });
    }
    function goToPages() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Pages);
        if (onPagesClick) {
            onPagesClick();
        }
        else {
            $state.go("dashboard", { nav: "pages" });
        }
    }
    function goToReports() {
        trackTabClicked(Navigation_1.NavigationTabNameForTelemetry.Reports);
        $state.go("dashboard", { nav: "reports" });
    }
    function trackTabClicked(tabName) {
        telemetry.trackOnly(Telemetry_1.TelemetryEventName.NavigationTabClicked, { navigation_tab: tabName }, {
            blockIntercom: true,
        });
    }
    var libraryOptions = [];
    var optionMenuSize = "small";
    if (isAdmin) {
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                goToLibraryDashboard(LibraryDashboardType.Templates);
            }, icon: react_1.default.createElement(icons_1.Template, null) }, "Templates"));
    }
    if (!hideBlocksButton) {
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: goToBlocks, icon: react_1.default.createElement(icons_1.Blocks, null) }, "Blocks"));
    }
    if (isAdmin) {
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                goToLibraryDashboard(LibraryDashboardType.EngagementLibrary);
            }, icon: react_1.default.createElement(icons_1.Engagement, null) }, "Engagement"));
    }
    if (isAdmin && usingFeature(FeatureFlag_1.default.HubspotSyncEssentials)) {
        optionMenuSize = "large";
        libraryOptions.push(react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                goToLibraryDashboard(LibraryDashboardType.Automations);
            }, icon: react_1.default.createElement(icons_1.Automation, null) },
            "Automations",
            " ",
            react_1.default.createElement("span", { className: NavHomeButtons_css_1.betaTag },
                react_1.default.createElement(BetaTag_1.BetaTag, null))));
    }
    var libraryOptionMenu = function () {
        return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(WrappedButton, { isActive: ["blocks", "templates", "automations"].includes(activeNav), isDropdown: true, syntheticsSelector: "nav-menu-library" }, "Library"), size: optionMenuSize, autoStack: true }, libraryOptions));
    };
    var renderLibraryOptions = function () {
        if (usingFeature(FeatureFlag_1.default.HubspotSyncEssentials) &&
            rootDataStore.getAccountDataStore().getPlanDisplayName() !== "Trial") {
            return (react_1.default.createElement(NewFeatureIndicator_1.NewFeatureIndicator, { className: c("new-feature-popup"), indicatorName: UseHistoryTypes_1.NewFeatureIndicatorName.AutomationsLibrary, content: react_1.default.createElement(AutomationsLibraryIndicator, null), position: kaleidoscope_1.TooltipPosition.Bottom, animation: true, dismissButton: true }, libraryOptionMenu()));
        }
        else {
            return libraryOptionMenu();
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.navBarZIndex }, function () { return (react_1.default.createElement("div", { className: c("left") },
        react_1.default.createElement("div", { className: c("items") },
            react_1.default.createElement(AppHomePagesButton, { label: "Pages", activeNav: activeNav, navName: "pages", onClick: goToPages }),
            isAdmin && libraryOptions.length > 0 ? (renderLibraryOptions()) : (react_1.default.createElement(react_1.default.Fragment, null, !hideBlocksButton && (react_1.default.createElement(AppHomePagesButton, { label: "Blocks", activeNav: activeNav, navName: "blocks", onClick: goToBlocks })))),
            react_1.default.createElement(AppHomePagesButton, { label: "Reports", activeNav: activeNav, navName: "reports", onClick: goToReports })))); }));
};
exports.NavHomeButtons = NavHomeButtons;
var AppHomePagesButton = function (_a) {
    var label = _a.label, navName = _a.navName, activeNav = _a.activeNav, onClick = _a.onClick;
    var isActive = activeNav && activeNav === navName;
    return (react_1.default.createElement(WrappedButton, { syntheticsSelector: "nav-menu-".concat(navName), isActive: isActive, onClick: onClick }, label));
};
var WrappedButton = (0, react_1.forwardRef)(function navButton(_a, ref) {
    var isActive = _a.isActive, onClick = _a.onClick, children = _a.children, _b = _a.isDropdown, isDropdown = _b === void 0 ? false : _b, syntheticsSelector = _a.syntheticsSelector;
    return (react_1.default.createElement(kaleidoscope_1.Button, { innerRef: ref, className: styles.navButton, onClick: onClick, type: kaleidoscope_1.ButtonType.Tertiary, "aria-current": isActive, size: kaleidoscope_1.ButtonSize.Small, decorator: isDropdown ? kaleidoscope_1.ButtonDecorator.Dropdown : undefined, "data-synthetics-selector": syntheticsSelector }, children));
});
var AutomationsLibraryIndicator = function () {
    return (react_1.default.createElement("div", { className: c("new-feature-popup__content") },
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true, className: c("new-feature-popup__content--heading") }, "\uD83E\uDD73 HubSpot Deal automations are here!"),
        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "xs", className: c("new-feature-popup__content--text") },
            "Be one of the first to access the highly requested new",
            react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", direction: "horizontal", align: "center", gap: "xxs" },
                react_1.default.createElement(icons_1.Qwilr, null),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Qwilr"),
                react_1.default.createElement(icons_1.ChevronRight, { size: icons_1.IconSize.Small }),
                react_1.default.createElement(icons_1.Hubspot, null),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "HubSpot")),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "automations"))));
};
